<template>
    <main-layout>
        <div class="form__page -pt-nav position-relative overflow-hidden min-height">

            <img src="@/assets/bg__allforms.png" alt="" class="form__allforms" />


            <div class="container d-flex justify-content-center">
                <div class="form__page-content col-sm-20 form__allforms-content">
                    <div class="form__row">
                        <div class="text-center">
                            <p class="form__title heading-32 -pb-1">
                                Formularz zgłoszeniowy - Etap I
                            </p>
                            <p class="text-20">
                                Program stypendialny dla uczniów
                            </p>
                        </div>
                    </div>

                    <div class="form__row -pt-4">
                        <div class="text-center">
                            <p class="form__title heading-32 -pb-4">
                                Osoba zgłaszająca do konkursu <span class="form__label form__label--red">*</span>
                            </p>
                        </div>
                        <reporting-person />
                    </div>

                    <div class="form__row -pt-4" v-if="person_reporting">
                        <div class="text-center">
                            <p class="form__title heading-32">
                                Osiągnięcia ucznia
                            </p>
                        </div>
                        <student-achievements />
                    </div>

                    <div class="form__row -pt-4" v-if="category && category != 'social'">
                        <div class="text-center">
                            <p class="form__title heading-32 -pb-1">
                                Najważniejsze osiągnięcia ucznia
                            </p>
                            <p class="text-20 -pb-4">Najbardziej znaczące osiągnięcia w latach 2023-2024<br>(można podać
                                maksymalnie 3 osiągnięcia).</p>
                        </div>
                        <student-most-achievements />
                    </div>

                    <div class="form__row -pt-4" v-if="category && category == 'social'">
                        <div class="text-center">
                            <p class="form__title heading-32 -pb-1">
                                Najważniejsze aktywności społeczne i ekologiczne ucznia
                            </p>
                            <p class="text-20 -pb-4">Najbardziej znaczące aktywności w latach 2023-2024 (można podać
                                maksymalnie 3 aktywności).</p>
                        </div>
                        <student-most-social />
                    </div>

                    <div class="form__row -pt-4" v-if="category && category != 'social'">
                        <div class="text-center">
                            <p class="form__title heading-32">
                                Działalność w samorządzie klasowym i szkolnym
                            </p>
                        </div>
                        <student-government-activity />
                    </div>

                    <div class="form__row -pt-4" v-if="category && category == 'social'">
                        <div class="text-center">
                            <p class="form__title heading-32">
                                Działalność w samorządzie klasowym i szkolnym
                            </p>
                        </div>
                        <student-government-activity-social />
                    </div>

                    <div class="form__row -pt-4" v-if="person_reporting">
                        <div class="text-center">
                            <p class="form__title heading-32">
                                Charakterystyka ucznia
                            </p>
                        </div>
                        <student-characterization />
                    </div>

                    <div class="form__row -pt-4" v-if="person_reporting">
                        <div class="text-center">
                            <p class="form__title heading-32">
                                O Enei Akademii Talentów dowiedziałem (-am) się: <span
                                    class="form__label form__label--red">*</span>
                            </p>
                            <div class="text-danger -pl-3" v-if="how_know_error">
                                {{ how_know_error }}
                            </div>
                        </div>
                        <student-how-know />
                    </div>

                    <div class="form__row -pb-4 form__rights" v-if="person_reporting == 'student'">
                        <p class="text-center form__title heading-32">Oświadczenia</p>

                        <div class="heading-16 form__pt-24" v-for="contactTerm of contactTerms" :key="contactTerm.id">
                            <p v-if="!readMoreActivated[contactTerm.id]"
                                class="text-start heading-16 form__description">
                                <span v-html="contactTerm.description.slice(0, 158)"></span>
                                <span
                                    v-if="!readMoreActivated[contactTerm.id] && contactTerm.description.length - 1 > 251"
                                    class="text-start text-16" @click.prevent="checkmarkExpand([contactTerm.id])"> ...
                                    <span class="heading-16 cur-pointer"> rozwiń</span></span>
                            </p>
                            <p v-if="readMoreActivated[contactTerm.id]" class="form__description">
                                <span v-html="contactTerm.description"></span>
                                <span class="form__checkmark-collapse text-start heading-16 cur-pointer"
                                    v-if="readMoreActivated[contactTerm.id]"
                                    @click.prevent="checkmarkCollapse([contactTerm.id])"> zwiń</span>
                            </p>
                        </div>

                        <div class="form-check form__pt-24 d-flex align-items-center form__gap-16">
                            <input v-model="agreement_all" class="form-check-input" type="checkbox"
                                id="flexCheckDefault">
                            <label class="form-check-label heading-16" for="flexCheckDefault">
                                Zaznacz wszystkie
                            </label>
                        </div>
                        <div class="form-check form__pt-24">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_1_error }" v-model="agreement_1"
                                    type="checkbox" id="flexCheckDefault">
                                <label class="form-check-label text-16" for="flexCheckDefault">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span> Oświadczam, że wszystkie
                                        dane zamieszczone w niniejszym formularzu są zgodne z prawdą i stanem faktycznym
                                        oraz że podaję je dobrowolnie.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_1_error">
                                {{ agreement_1_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_2_error }" v-model="agreement_2"
                                    type="checkbox" id="flexCheckDefault">
                                <label class="form-check-label text-16" for="flexCheckDefault">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span> Potwierdzam, że zapoznałem
                                        się z regulaminem akcji „Enea Akademia Talentów” oraz załącznikami do niego,
                                        wyrażam zgodę na jego postanowienia i zobowiązuję się do przestrzegania
                                        określonych w nim zasad.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_2_error">
                                {{ agreement_2_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_3_error }" v-model="agreement_3"
                                    type="checkbox" id="flexCheckDefault">
                                <label class="form-check-label text-16" for="flexCheckDefault">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span> Wyrażam zgodę na
                                        przetwarzanie moich danych osobowych podanych w formularzu zgłoszeniowym oraz w
                                        dokumentach do niego załączonych w celach związanych z realizacją akcji, w tym w
                                        celu kontaktu ze mną jako wnioskodawcą, oceny zgłoszenia do udziału w akcji,
                                        zakwalifikowania ucznia do II etapu akcji, wydania nagrody, ogłoszenia wyników,
                                        rozpatrzenia reklamacji.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_3_error">
                                {{ agreement_3_error }}
                            </div>
                        </div>
                    </div>

                    <div class="form__row -pb-4 form__rights" v-if="person_reporting == 'parent'">
                        <p class="text-center form__title heading-32">Oświadczenia</p>

                        <div class="heading-16 form__pt-24" v-for="contactTerm of contactTerms" :key="contactTerm.id">
                            <p v-if="!readMoreActivated[contactTerm.id]"
                                class="text-start heading-16 form__description">
                                <span v-html="contactTerm.description.slice(0, 158)"></span>
                                <span
                                    v-if="!readMoreActivated[contactTerm.id] && contactTerm.description.length - 1 > 251"
                                    class="text-start text-16" @click.prevent="checkmarkExpand([contactTerm.id])">...
                                    <span class="heading-16 cur-pointer">rozwiń</span></span>
                            </p>
                            <p v-if="readMoreActivated[contactTerm.id]" class="form__description">
                                <span v-html="contactTerm.description"></span>
                                <span class="form__checkmark-collapse text-start heading-16 cur-pointer"
                                    v-if="readMoreActivated[contactTerm.id]"
                                    @click.prevent="checkmarkCollapse([contactTerm.id])">zwiń</span>
                            </p>
                        </div>

                        <div class="form-check form__pt-24 d-flex align-items-center form__gap-16">
                            <input v-model="agreement_all" class="form-check-input" type="checkbox"
                                id="flexCheckDefault">
                            <label class="form-check-label heading-16" for="flexCheckDefault">
                                Zaznacz wszystkie
                            </label>
                        </div>
                        <div class="form-check form__pt-24">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_1_error }" v-model="agreement_1"
                                    type="checkbox" id="flexCheckDefault">
                                <label class="form-check-label text-16" for="flexCheckDefault">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span> Oświadczam, że wszystkie
                                        dane zamieszczone w niniejszym formularzu są zgodne z prawdą i stanem faktycznym
                                        oraz że podaję je dobrowolnie.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_1_error">
                                {{ agreement_1_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_2_error }" v-model="agreement_2"
                                    type="checkbox" id="flexCheckDefault">
                                <label class="form-check-label text-16" for="flexCheckDefault">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span> Potwierdzam, że zapoznałem
                                        się z regulaminem akcji „Enea Akademia Talentów” oraz załącznikami do niego,
                                        wyrażam zgodę na jego postanowienia i zobowiązuję się do przestrzegania
                                        określonych w nim zasad.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_2_error">
                                {{ agreement_2_error }}
                            </div>
                        </div>
                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_3_error }" v-model="agreement_3"
                                    type="checkbox" id="flexCheckDefault">
                                <label class="form-check-label text-16" for="flexCheckDefault">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span> Wyrażam zgodę na
                                        uczestnictwo mojej córki/mojego syna/podopiecznego w akcji „Enea Akademia
                                        Talentów”.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_3_error">
                                {{ agreement_3_error }}
                            </div>
                        </div>

                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_4_error }" v-model="agreement_4"
                                    type="checkbox" id="flexCheckDefault">
                                <label class="form-check-label text-16" for="flexCheckDefault">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span> Wyrażam zgodę na
                                        przetwarzanie danych osobowych mojej córki/mojego syna/podopiecznego podanych w
                                        formularzu zgłoszeniowym oraz w dokumentach do niego załączonych w celach
                                        związanych z realizacją akcji, w tym w celu kontaktu z uczestnikiem, oceny
                                        zgłoszenia do udziału w akcji, zakwalifikowania ucznia do II etapu akcji,
                                        wydania nagrody, ogłoszenia wyników, rozpatrzenia reklamacji.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_4_error">
                                {{ agreement_4_error }}
                            </div>
                        </div>

                        <div class="form-check form__pt-24 ">
                            <div class="d-flex align-sm-items-center form__gap-16">
                                <input class="form-check-input"
                                    :class="{ 'form-check-input__error': agreement_5_error }" v-model="agreement_5"
                                    type="checkbox" id="flexCheckDefault">
                                <label class="form-check-label text-16" for="flexCheckDefault">
                                    <p class="description-16">
                                        <span class="form__label form__label--red">*</span> Wyrażam zgodę na
                                        przetwarzanie moich danych osobowych podanych w formularzu zgłoszeniowym oraz w
                                        dokumentach do niego załączonych w celach związanych z realizacją akcji, w tym w
                                        celu kontaktu ze mną jako wnioskodawcą, oceny zgłoszenia do udziału w akcji,
                                        zakwalifikowania ucznia do II etapu akcji, wydania nagrody, ogłoszenia wyników,
                                        rozpatrzenia reklamacji.
                                    </p>
                                </label>
                            </div>
                            <div class="text-danger -pl-3" v-if="agreement_5_error">
                                {{ agreement_5_error }}
                            </div>
                        </div>
                    </div>

                    <div class="form__row py-2" v-if="recaptcha_error">
                        <div class="text-center">
                            <p class="text-danger form__title heading-32">
                                Błąd przesyłania recaptcha. Jeżeli błąd będzie pojawiać się dalej, skontaktuj się z
                                organizatorem konkursu przez formularz kontaktowy.
                            </p>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center -pb-6" v-if="person_reporting">
                        <button class="button__red form__btn" @click="sendForm" :disabled="sendFormLoader">
                            <div v-if="sendFormLoader">
                                <svg style="width: 20px; height: 20px;" version="1.1" id="L9"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0"
                                    xml:space="preserve">
                                    <path fill="#fff"
                                        d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                                        <animateTransform attributeName="transform" attributeType="XML" type="rotate"
                                            dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" />
                                    </path>
                                </svg>
                            </div>
                            <span>Zapisz&nbsp;i&nbsp;wyślij</span>
                            <img src="@/assets/right-btn.svg" alt="" class="button__arrow" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <transition name="fade">
            <modal-success v-if="showModal.show" @close-modal="() => showModal.show = false" :type="showModal.type" />
        </transition>

    </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import ReportingPerson from "@/components/forms/ReportingPerson.vue";
import StudentAchievements from "@/components/forms/StudentAchievements.vue";
import StudentMostAchievements from "@/components/forms/StudentMostAchievements.vue";
import StudentMostSocial from "@/components/forms/StudentMostSocial.vue";
import StudentGovernmentActivity from "@/components/forms/StudentGovernmentActivity.vue";
import StudentGovernmentActivitySocial from "@/components/forms/StudentGovernmentActivitySocial.vue";
import StudentCharacterization from "@/components/forms/StudentCharacterization.vue";
import StudentHowKnow from "@/components/forms/StudentHowKnow.vue";
import ModalSuccess from "@/components/forms/ModalSuccess.vue";
import axios from "axios";

export default {
    data() {
        return {
            sendFormLoader: false,
            showModal: {
                type: 'success',
                show: false,
            },
            agreement_all: false,
            agreement_1: false,
            agreement_2: false,
            agreement_3: false,
            agreement_4: false,
            agreement_5: false,
            readMoreActivated: {},
            contactTerms: [
                {
                    id: "1",
                    description:
                        "Współadministratorem danych osobowych Wnioskodawców (wedle definicji Regulaminu Akcji dla Uczniów) Uczestników (wedle definicji regulaminu Akcji dla Uczniów), osób, których wizerunek lub głos został utrwalony w Zadaniu konkursowym oraz osób, których przedmioty praw, w tym utwory lub artystyczne wykonania zostały wykorzystane w Zadaniu konkursowym jest Enea S.A. z siedzibą w Poznaniu (60-198), przy Pastelowej 8 wpisana do rejestru przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy Poznań - Nowe Miasto i Wilda w Poznaniu, VIII Wydział Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS 0000012483, NIP 777-00-20-640, REGON 630139960, kapitał zakładowy: 441 442 578 zł wpłacony w całości oraz Fundacja Enea z siedzibą w Poznaniu (60-198), przy Pastelowej 8 wpisana do rejestru stowarzyszeń, innych organizacji społecznych i zawodowych, fundacji oraz samodzielnych publicznych zakładów opieki zdrowotnej Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy Poznań – Nowe Miasto i Wilda, VIII Wydział Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS 0000505487, NIP: 779-24-21-429, REGON: 302710647 <br> Dane osobowe będą przetwarzane zgodnie z przepisami Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE - Dz. U. UE. L. z 2016 r. Nr 119/1 (RODO) w  celach związanych z realizacją Akcji, w tym w celu kontaktu z Wnioskodawcą, oceny jego zgłoszenia do udziału w Akcji, zakwalifikowania do II Etapu Akcji, ogłoszenia wyników, wydania Nagrody, rozpatrzenia reklamacji, w związku z możliwością ustalenia, dochodzenia lub obrony roszczeń. <br> Podstawą przetwarzania danych osobowych jest zgoda w oparciu o art. 6 ust. 1 lit. a) RODO w celach związanych z realizacją Akcji, w tym w celu kontaktu z Wnioskodawcą, oceny jego zgłoszenia do udziału w Akcji, zakwalifikowania do II Etapu Akcji, ogłoszenia wyników, wydania Nagrody, rozpatrzenia reklamacji, a w zakresie danych przetwarzanych w związku z możliwością ustalenia, dochodzenia lub obrony roszczeń, na podstawie art. 6 ust. 1 lit. f) RODO. <br> Dane osobowe będą przetwarzane do 15 marca 2025 roku, a w przypadku przyznania stypendium przez okres do 31 grudnia 2025 r., a po tym okresie – dla celów związanych z możliwością ustalenia, dochodzenia lub obrony roszczeń - przez czas niezbędny do ich ustalenia, dochodzenia lub obrony, nie dłużej jednak niż do upływu okresu przedawnienia. <br><br> Osoba, której dane dotyczą ma prawo żądania: <br> a) dostępu do treści swoich danych - w granicach art. 15 RODO, <br> b) ich sprostowania – w granicach art. 16 RODO, <br> c) ich usunięcia - w granicach art. 17 RODO, <br> d) ograniczenia przetwarzania - w granicach art. 18 RODO, <br> e) przenoszenia danych - w granicach art. 20 RODO, <br> f) wniesienia sprzeciwu wobec przetwarzania danych osobowych opartego na art. 6 ust. 1 lit. f) RODO - w granicach art. 21 RODO. <br><br> W odniesieniu do danych osobowych przetwarzanych na podstawie zgody osoba, której dane dotyczą ma prawo do cofnięcia zgody w dowolnym momencie, przy czym wycofanie zgody nie wpływa na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem. Cofnięcie zgody jest możliwe w formie pisemnej poprzez przesłanie jej na adres: Inspektor Ochrony Danych (IOD) Enea S.A., ul. Pastelowa 8, 60-198 Poznań lub na adres mailowy esa.iod@enea.pl. <br> Współadministrator może ujawnić dane osobowe podmiotom upoważnionym na podstawie przepisów prawa. <br> Współadministrator może również powierzyć przetwarzanie danych osobowych dostawcom usług lub produktów działającym na jego rzecz, w szczególności podmiotom świadczącym Administratorowi usługi IT, księgowe, transportowe, serwisowe, agencyjne. <br> Zgodnie z zawartymi z takimi podmiotami umowami powierzenia przetwarzania danych osobowych, Współadministrator wymaga od tych dostawców usług zgodnego z przepisami prawa, wysokiego stopnia ochrony prywatności i bezpieczeństwa danych osobowych przetwarzanych przez nich w imieniu Współadministratora. <br> Współadministratorzy postanowili o ustanowieniu wspólnego punktu kontaktowego wobec czego realizacja praw, o których mowa powyżej może odbywać się poprzez wskazanie żądań przesłane na adres: esa.iod@enea.pl  lub pisemnie na adres: Inspektor Ochrony Danych (IOD) Enea S.A., ul. Pastelowa 8, 60-198 Poznań. <br> Niezależnie od powyższego każdy ze Współadministratorów ponosi solidarną odpowiedzialność za wszelkie naruszenia w procesie przetwarzania danych.  Osoba, której dane dotyczą może zgłosić swoje roszczenia wybranemu Współadministratorowi, który będzie zobowiązany do naprawienia szkody, nawet jeśli wyrządził ją inny Współadministrator. Tym samym, osoba, której dane dotyczą, ma prawo do kierowania roszczeń przeciwko któremukolwiek ze Współadministratorów. <br> Osoba, której dane dotyczą ma prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych, gdy uzna, iż przetwarzanie danych osobowych jej dotyczących narusza przepisy prawa dotyczące przetwarzania danych osobowych; kontakt: ul. Stawki 2, 00-193 Warszawa, tel.: 22 531 03 00, fax: 22 531 03 01, e-mail: kancelaria@uodo.gov.pl. <br> Dane osobowe nie będą przekazywane do państwa trzeciego/organizacji międzynarodowej. <br> W oparciu o dane osobowe Współadministrator nie będzie podejmował decyzji w sposób zautomatyzowany, w tym również w formie profilowania. <br><br> Administratorem danych osobowych przetwarzanych w celu wykonania Umowy stypendialnej oraz w celu przekazania Nagrody - wypłaty Stypendium, zapłaty zaliczki na podatek dochodowy  oraz w celu wystawienia przez Fundatora PIT 8C zgodnie z ustawą z dnia 26.07.1991 roku o podatku dochodowym od osób fizycznych jest Fundacja Enea z siedzibą w Poznaniu (60-198), przy Pastelowej 8 wpisana do rejestru stowarzyszeń, innych organizacji społecznych i zawodowych, fundacji oraz samodzielnych publicznych zakładów opieki zdrowotnej Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy Poznań – Nowe Miasto i Wilda, VIII Wydział Gospodarczy Krajowego Rejestru Sądowego, pod numerem KRS 0000505487, NIP: 779-24-21-429, REGON: 302710647. Szczegółowa treść klauzuli informacyjna dołączona do wzoru Umowy stypendialnej stanowiącej załącznik do Regulaminu Akcji dla Uczniów. ",
                    checked: false,
                    required: true,
                },
            ],
        }
    },
    mounted() {
        this.$store.commit('removeAllErrors');
        this.$store.commit('resetFormStudent');

        const resize_ob = new ResizeObserver(function (entries) {
            let rect = entries[0].target;
            rect.style.backgroundColor = "#fffffs"
            setTimeout(() => {
                // entries.style.backgroundColor = 'red'
                rect.style.backgroundColor = "#fff"
                // console.log(rect, entries, test)
            }, 10);
        });
        const rows = document.querySelectorAll('.form__row');
        rows.forEach((item) => {
            console.log(item)
            resize_ob.observe(item);
        });


    },
    computed: {
        category() {
            return this.$store.getters.getValuByPath('formStudent.student.category');
        },
        person_reporting() {
            return this.$store.getters.getValuByPath('formStudent.student.person_reporting');
        },
        how_know_error() {
            const error = this.$store.getters.getError('student.how_know');
            if (error && error.length)
                return error[0]

            return null
        },
        agreement_1_error() {
            const error = this.$store.getters.getError('application.agreement_1');
            if (error && error.length)
                return error[0]

            return null
        },
        agreement_2_error() {
            const error = this.$store.getters.getError('application.agreement_2');
            if (error && error.length)
                return error[0]

            return null
        },
        agreement_3_error() {
            const error = this.$store.getters.getError('application.agreement_3');
            if (error && error.length)
                return error[0]

            return null
        },
        agreement_4_error() {
            const error = this.$store.getters.getError('application.agreement_4');
            if (error && error.length)
                return error[0]

            return null
        },
        agreement_5_error() {
            const error = this.$store.getters.getError('application.agreement_5');
            if (error && error.length)
                return error[0]

            return null
        },
        recaptcha_error() {
            const error = this.$store.getters.getError('grecaptcha_token');
            if (error && error.length)
                return error[0]

            return null
        }
    },
    watch: {
        agreement_all(newVal) {
            if (newVal) {
                this.agreement_1 = true;
                this.agreement_2 = true;
                this.agreement_3 = true;
                this.agreement_4 = true;
                this.agreement_5 = true;
            }
        },
        agreement_1(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formStudent.application.agreement_1', !newVal ? null : true);
            this.$store.commit('removeError', 'formStudent.application.agreement_1')
        },
        agreement_2(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formStudent.application.agreement_2', !newVal ? null : true);
            this.$store.commit('removeError', 'formStudent.application.agreement_2')
        },
        agreement_3(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formStudent.application.agreement_3', !newVal ? null : true);
            this.$store.commit('removeError', 'formStudent.application.agreement_3')
        },
        agreement_4(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formStudent.application.agreement_4', !newVal ? null : true);
            this.$store.commit('removeError', 'formStudent.application.agreement_4')
        },
        agreement_5(newVal) {
            if (!newVal)
                this.agreement_all = null;
            this.updateFormValue('formStudent.application.agreement_5', !newVal ? null : true);
            this.$store.commit('removeError', 'formStudent.application.agreement_5')
        },
    },
    components: {
        MainLayout,
        ModalSuccess,
        // forms section
        ReportingPerson,
        StudentAchievements,
        StudentMostAchievements,
        StudentMostSocial,
        StudentGovernmentActivity,
        StudentCharacterization,
        StudentHowKnow,
        StudentGovernmentActivitySocial
    },
    methods: {
        checkmarkExpand(id) {
            this.readMoreActivated[id] = true;
        },
        checkmarkCollapse(id) {
            this.readMoreActivated[id] = false;
        },
        scrollToElement() {
            setTimeout(() => {

                const el = document.querySelector('.text-danger');

                if (el) {
                    // Use el.scrollIntoView() to instantly scroll to the element
                    el.scrollIntoView({ behavior: 'smooth' });

                    const pos = el.style.position;
                    const top = el.style.top;
                    el.style.position = 'relative';
                    el.style.top = '-200px';
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    el.style.top = top;
                    el.style.position = pos;
                }
            }, 200);
        },
        async sendForm() {
            this.sendFormLoader = true;
            this.$store.commit('removeAllErrors');

            await this.$recaptchaLoaded();
            const token = await this.$recaptcha("form");
            const form = this.$store.getters.getValuByPath('formStudent')

            axios
                .post(process.env.VUE_APP_API_BASE_URL + "applications", {
                    ...form,
                    grecaptcha_token: token,
                })
                .then((response) => {
                    if (response.status == 200 && response.data.id > 0) {
                        this.showModal.type = 'success'
                        this.showModal.show = true
                    } else {
                        this.showModal.type = 'server-error'
                        this.showModal.show = true
                    }
                    this.sendFormLoader = false;
                })
                .catch((error) => {
                    if (error.response.data.errors) {
                        this.$store.commit('setErrors', error.response.data.errors);
                        this.scrollToElement();
                    } else {
                        this.showModal.type = 'server-error'
                        this.showModal.show = true
                    }
                    this.sendFormLoader = false;
                });
        },
    },
};
</script>
